import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#CAEFFF',
    },
  },
  typography: {
    fontFamily: '"M PLUS 1", sans-serif',
  },
  dimensions: {
    pageWidth: '1180px',
    breakpoint: '960px',
    headerHeight: '100px',
  },
  flexGapPolyfill: true,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          '@global': {
            '*': {
              'scrollbar-width': 'thin',
            },
            '*::-webkit-scrollbar': {
              width: '4px',
            },
            '*::-webkit-scrollbar-thumb': {
              backgroundColor: '#caefff',
              borderRadius: ' 4px',
            },
          },
        },
      },
    },
  },
});

export default theme;
